export type MentoringProgramReflectionSummary = {
  firstSessionDate: string;
  lastSessionDate: string;
  pastSessionsCount: number;
  pastSessionsDurationSum: number;
};

export const defaultMentoringProgramReflectionSummary: MentoringProgramReflectionSummary = {
  firstSessionDate: '',
  lastSessionDate: '',
  pastSessionsCount: 0,
  pastSessionsDurationSum: 0,
};

export type MentoringProgramReflectionQuestion = {
  id: number;
  questionIndex: number;
  questionText: string;
};

export type MentoringProgramReflectionQuestionResponse = {
  questionId: number;
  response: string;
};

export type MentoringProgramReflectionResponse = MentoringProgramReflectionQuestionResponse & {
  id: number;
};

export type MentoringProgramReflectionParticipantResponses = {
  mentorshipProgramEnrollmentId: number;
  answers: MentoringProgramReflectionResponse[];
};
